require([
  //load root dependencies from here
  "pym",
  "jquery",
  "litetooltip.js",

], function(pym) {

	var child = new pym.Child();

  setInterval(child.sendHeight.bind(child), 500);
  
  // Code kicks off here
  $('.litetooltip-hotspot-wrapper .hotspot').each(function () { 
    $(this).LiteTooltip({ title: $(this).find('.data-container').html() });
 });
});

define("main", function(){});

